import React, { useEffect, useState } from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'
import Management from './Management';
import { useDispatch } from 'react-redux';
import { clearOrderResponse } from '../redux/slices/Order/GetOrderList';

const OrderManagement = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const role = location.state?.role || searchParams.get('role');

    const [supplierType, setSupplierType] = useState(1);
    const [viewKey, setViewKey] = useState(''); // to force Management remount
    // const [currentPage, setCurrentPage] = useState(1);
    // const [limit, setLimit] = useState(5);
    const handleTabChange = (type) => {
        setSupplierType(type);
        dispatch(clearOrderResponse()); // clear redux
        setViewKey(`${Date.now()}`); // force Management remount
    };

    useEffect(() => {
        setSupplierType(1);
        // setCurrentPage(1);
        // setLimit(5);
    }, [location]);

    useEffect(() => {
        setSupplierType(1);
        dispatch(clearOrderResponse()); // clear redux
        setViewKey(`${Date.now()}`); // force Management remount
    }, [role]);

    return (
        <>
            {role == 'supplier' &&
                <section className='main'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12'>
                                <div className='common_tabs'>
                                    <nav>
                                        <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                            <button
                                                className="nav-link active"
                                                id="nav-cmt-1-tab"
                                                data-bs-toggle="tab"
                                                data-bs-target="#nav-cmt-1"
                                                type="button"
                                                role="tab"
                                                aria-controls="nav-cmt-1"
                                                aria-selected="true"
                                                onClick={() => handleTabChange(1)}
                                            >
                                                Orders Requested by Suppliers
                                            </button>
                                            <button
                                                className="nav-link"
                                                id="nav-cmt-2-tab"
                                                data-bs-toggle="tab"
                                                data-bs-target="#nav-cmt-2"
                                                type="button"
                                                role="tab"
                                                aria-controls="nav-cmt-2"
                                                aria-selected="true"
                                                onClick={() => handleTabChange(2)}
                                            >
                                                Orders Requested by Farmers Market
                                            </button>
                                        </div>
                                    </nav>
                                    <div className="tab-content" id="nav-tabContent">
                                        <div className="tab-pane show active" id="nav-cmt-1" role="tabpanel" aria-labelledby="nav-cmt-1-tab" tabIndex={0}>
                                            {/* Using key prop to force component remount and reset pagination when switching tabs */}
                                            {supplierType === 1 && <Management key={`supplier-${supplierType}`} role={role} supplierType={supplierType} />}
                                        </div>
                                        <div className="tab-pane fade" id="nav-cmt-2" role="tabpanel" aria-labelledby="nav-cmt-2-tab" tabIndex={0}>
                                            {/* Using key prop to force component remount and reset pagination when switching tabs */}
                                            {supplierType === 2 && <Management key={`supplier-${supplierType}`} role={role} supplierType={supplierType} />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            }
            {/* {role == 'restaurant' && <Management key={`supplier-${role}`} role={role} />}
            {role == 'customer' && <Management key={`supplier-${role}`} role={role} />} */}
            {(role === 'restaurant' || role === 'customer') && (
                <Management key={`${role}-${Date.now()}`} role={role} />
            )}
        </>
    )
}

export default OrderManagement